import { Main } from '@/components/layout/main'
import { TagsDataTable } from './components/data-table'
import { TagsDialogs } from './components/tags-dialogs'
import { TagsPrimaryButtons } from './components/tags-primary-buttons'
import TagsProvider from './context/tags-context'

export default function Tags() {
  return (
    <TagsProvider>
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between gap-x-4 space-y-2'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Segmentos</h2>
            <p className='text-muted-foreground'>
              Aqui você gerencia os segmentos dos seus contatos.
            </p>
          </div>
          <TagsPrimaryButtons />
        </div>
        <div className='-mx-4 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-x-12 lg:space-y-0'>
          <TagsDataTable />
        </div>
      </Main>

      <TagsDialogs />
    </TagsProvider>
  )
}
